import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';
import { Box } from 'src/components/Box';

// Extend the SvgIcon props to include 'alert' as a valid color option
declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    alert: true;
  }
}

export interface IconProps {
  icon: IconDefinition;
  color?: SvgIconProps['color'];
  sx?: SvgIconProps['sx'];
  size?: 'inherit' | 'large' | 'medium' | 'small' | 'xsmall' | 'tiny';
}

const sizes = {
  large: '32px',
  medium: '20px',
  small: '16px',
  xsmall: '14px',
  tiny: '12px',
  inherit: 'inherit',
};

export const Icon = forwardRef<HTMLSpanElement, IconProps>(
  ({ icon, sx, color, size = 'medium', ...props }, ref) => {
    const iconColor = color === 'inherit' ? color : color + '.text';
    return (
      <Box
        component={FontAwesomeIcon}
        ref={ref}
        sx={[
          { fontSize: sizes[size], color: iconColor },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        fixedWidth
        icon={icon}
        {...props}
      />
    );
  }
);

Icon.displayName = 'Icon';

export type { IconDefinition };
